export default class ControlProductInfo {
  constructor(productData, nameOfControlSet) {
    const setIdentifier = productData.set_identifier || '';
    const id = productData.id;

    this.set = nameOfControlSet;
    this.product = productData;

    this.id = `${id}_${setIdentifier}`;
  }
}



// WEBPACK FOOTER //
// ./js/utils/project-definition/component/controls/ControlProductInfo.js